import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["filteredOptions", "getItemProps", "getPopperAttributes", "open", "listItemComponent", "tokens"],
    _excluded2 = ["open", "modalRef", "filteredOptions", "getItemProps", "menuProps", "onAccept", "onCancel", "mobileConfirmationBehaviour", "listItemComponent", "modalHeadline", "tokens"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { useTheme } from '@emotion/react';
import { createPortal } from 'react-dom';
import { AppearanceProvider, useAppearance } from '@segment/matcha/foundations/AppearanceContext';
import ButtonText from '@segment/matcha/components/ButtonText';
import * as Menu from '@segment/matcha/components/Menu';
import ModalBase, * as Modal from '@segment/matcha/components/Modal';
import { ClearIcon } from '@segment/matcha/components/Icons/Common';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import useMatchMedia from '@segment/utils/useMatchMedia';
import usePortal from '@segment/utils/usePortal';
import * as views from './Select.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
var SelectMenu = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var filteredOptions = _ref.filteredOptions,
      getItemProps = _ref.getItemProps,
      getPopperAttributes = _ref.getPopperAttributes,
      open = _ref.open,
      listItemComponent = _ref.listItemComponent,
      tokens = _ref.tokens,
      rest = _objectWithoutProperties(_ref, _excluded);

  var theme = useTheme();
  var desktopResolutionMediaQuery = theme.breakpoints.up("lg", false);
  var isDesktopResolution = useMatchMedia(desktopResolutionMediaQuery, true);

  var menuProps = _objectSpread({
    layout: isDesktopResolution
  }, rest);

  var ListItemComponent = listItemComponent;
  return _jsx(views.MenuWrapper, _objectSpread(_objectSpread({}, getPopperAttributes === null || getPopperAttributes === void 0 ? void 0 : getPopperAttributes()), {}, {
    ref: ref,
    children: open && _jsxs(views.Menu, _objectSpread(_objectSpread({}, menuProps), {}, {
      children: [filteredOptions.map(function (el, index) {
        return (// eslint-disable-next-line react/jsx-key
          _jsx(ListItemComponent, _objectSpread(_objectSpread({}, getItemProps(el, index)), {}, {
            children: el.text
          }))
        );
      }), !filteredOptions.length && _jsx(views.EmptyState, {
        tag: "div",
        variant: "formHint",
        tokens: tokens.emptyState,
        children: "No options"
      })]
    }))
  }));
});
var DesktopWrapper = SelectMenu;

var ModalWrapper = function ModalWrapper(_ref2) {
  var open = _ref2.open,
      modalRef = _ref2.modalRef,
      filteredOptions = _ref2.filteredOptions,
      getItemProps = _ref2.getItemProps,
      menuProps = _ref2.menuProps,
      onAccept = _ref2.onAccept,
      onCancel = _ref2.onCancel,
      mobileConfirmationBehaviour = _ref2.mobileConfirmationBehaviour,
      listItemComponent = _ref2.listItemComponent,
      modalHeadline = _ref2.modalHeadline,
      tokens = _ref2.tokens,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  var portal = usePortal(rest.id);
  return _jsx(_Fragment, {
    children: open && /*#__PURE__*/createPortal(_jsxs(ModalBase, _objectSpread(_objectSpread({
      ref: modalRef
    }, rest), {}, {
      children: [_jsxs(Modal.Head, {
        children: [_jsx(views.ModalHeading, {
          tokens: tokens.modal.heading,
          variant: "buttonLarge",
          children: modalHeadline
        }), _jsx(views.ClosingIcon, _objectSpread(_objectSpread({
          onClick: function onClick() {
            return onCancel === null || onCancel === void 0 ? void 0 : onCancel();
          },
          "aria-label": "Close the modal"
        }, tokens.modal.closeIcon), {}, {
          children: _jsx(ClearIcon, {
            size: "large"
          })
        }))]
      }), _jsx(views.ModalBody, {
        children: _jsx(SelectMenu, _objectSpread({
          listItemComponent: listItemComponent,
          filteredOptions: filteredOptions,
          getItemProps: getItemProps,
          open: true,
          tokens: tokens.menu
        }, menuProps))
      }), mobileConfirmationBehaviour && _jsx(Modal.Footer, {
        children: _jsxs(views.ButtonsWrapper, {
          children: [_jsx(ButtonText, {
            size: "small",
            onClick: function onClick() {
              return onCancel === null || onCancel === void 0 ? void 0 : onCancel();
            },
            "aria-label": "Cancel",
            tokens: tokens.modal.cancelButton,
            children: "Cancel"
          }), _jsx(ButtonText, {
            size: "small",
            onClick: function onClick() {
              onAccept === null || onAccept === void 0 ? void 0 : onAccept();
            },
            tokens: tokens.modal.doneButton,
            children: "Done"
          })]
        })
      })]
    })), portal)
  });
};

var BaseSelect = /*#__PURE__*/forwardRef(function (_ref3, ref) {
  var id = _ref3.id,
      filteredOptions = _ref3.filteredOptions,
      onAccept = _ref3.onAccept,
      onCancel = _ref3.onCancel,
      getPopperAttributes = _ref3.getPopperAttributes,
      getMenuContainerProps = _ref3.getMenuContainerProps,
      getMenuListProps = _ref3.getMenuListProps,
      getItemProps = _ref3.getItemProps,
      open = _ref3.open,
      displayMode = _ref3.displayMode,
      modalRef = _ref3.modalRef,
      externalAppearance = _ref3.appearance,
      _ref3$mobileConfirmat = _ref3.mobileConfirmationBehaviour,
      mobileConfirmationBehaviour = _ref3$mobileConfirmat === void 0 ? true : _ref3$mobileConfirmat,
      _ref3$listItemCompone = _ref3.listItemComponent,
      listItemComponent = _ref3$listItemCompone === void 0 ? Menu.Item : _ref3$listItemCompone,
      ariaLabel = _ref3.ariaLabel,
      _ref3$modalHeadline = _ref3.modalHeadline,
      modalHeadline = _ref3$modalHeadline === void 0 ? "Select a category" : _ref3$modalHeadline,
      tokens = _ref3.tokens;
  var menuProps = getMenuListProps();
  var appearance = useAppearance(externalAppearance);
  var placementWrapper = null;

  if (displayMode === "desktop") {
    placementWrapper = _jsx(DesktopWrapper, _objectSpread({
      id: id,
      filteredOptions: filteredOptions,
      getItemProps: getItemProps,
      getPopperAttributes: getPopperAttributes,
      open: open,
      listItemComponent: listItemComponent,
      "aria-label": ariaLabel,
      tokens: tokens.menu
    }, getMenuContainerProps(menuProps)));
  }

  if (displayMode === "mobile") {
    placementWrapper = _jsx(ModalWrapper, _objectSpread({
      id: id,
      filteredOptions: filteredOptions,
      open: open,
      modalRef: modalRef,
      modalHeadline: modalHeadline,
      menuProps: menuProps,
      getItemProps: getItemProps,
      onAccept: onAccept,
      onCancel: onCancel,
      mobileConfirmationBehaviour: mobileConfirmationBehaviour,
      listItemComponent: listItemComponent,
      tokens: tokens
    }, getMenuContainerProps()));
  }

  return _jsx(AppearanceProvider, {
    appearance: appearance,
    children: _jsx(views.Wrapper, {
      ref: ref,
      children: placementWrapper
    })
  });
});
export var Select = withDesignTokens(BaseSelect, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      menu: {
        emptyState: {
          color: theme.palette.brand.darkAcai[500]
        }
      },
      modal: {
        heading: {
          color: theme.palette.neutrals.black[100]
        },
        closeIcon: {
          color: theme.palette.brand.darkAcai[700]
        },
        doneButton: {
          textColor: theme.palette.brand.darkAcai[700],
          hoverColor: theme.palette.brand.darkAcai[700]
        },
        cancelButton: {
          textColor: theme.palette.brand.darkAcai[500],
          hoverColor: theme.palette.brand.darkAcai[500]
        }
      }
    };
  },
  dark: function dark(theme) {
    return {
      menu: {
        emptyState: {
          color: theme.palette.brand.darkAcai[400]
        }
      },
      modal: {
        heading: {
          color: theme.palette.neutrals.white[100]
        },
        closeIcon: {
          color: theme.palette.neutrals.white[100]
        },
        doneButton: {
          textColor: theme.palette.neutrals.white[100],
          hoverColor: theme.palette.neutrals.white[100]
        },
        cancelButton: {
          textColor: theme.palette.brand.darkAcai[400],
          hoverColor: theme.palette.brand.darkAcai[400]
        }
      }
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      menu: {
        emptyState: {
          color: theme.palette.twilio.gray[80]
        }
      },
      modal: {
        heading: {
          color: theme.palette.twilio.gray[100]
        },
        closeIcon: {
          color: theme.palette.twilio.gray[100]
        },
        doneButton: {
          textColor: theme.palette.twilio.gray[100],
          hoverColor: theme.palette.twilio.gray[100]
        },
        cancelButton: {
          textColor: theme.palette.twilio.gray[80],
          hoverColor: theme.palette.twilio.gray[80]
        }
      }
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      menu: {
        emptyState: {
          color: theme.palette.twilio.gray[80]
        }
      },
      modal: {
        heading: {
          color: theme.palette.twilio.gray[100]
        },
        closeIcon: {
          color: theme.palette.twilio.gray[100]
        },
        doneButton: {
          textColor: theme.palette.twilio.gray[100],
          hoverColor: theme.palette.twilio.gray[100]
        },
        cancelButton: {
          textColor: theme.palette.twilio.gray[80],
          hoverColor: theme.palette.twilio.gray[80]
        }
      }
    };
  }
});